import { UploadToExcel } from './upload';
import { Tab, Tabs, Box } from '@mui/material';
import { TabPanel, a11yProps } from 'components/tabPanel';
import styles from 'assets/styles/modal.module.scss';
import ExcelTable from './table';
import { useState } from 'react';
import CustomModal from 'components/modal';

type Props = {
  open: any;
  close: any;
  refetch: any;
};

export default function ImportFile({ open, close, refetch }: Props) {
  const [current, setCurrent] = useState(0);

  // submit state
  const [excelData, setExcelData] = useState(null);

  const next = () => setCurrent((step: number) => step + 1);

  const prev = () => setCurrent((step: number) => step - 1);

  return (
    <CustomModal width={current === 1 ? '90%' : '50%'} open={open} close={close}>
      <Box className={styles.modal}>
        <Tabs
          value={current}
          sx={{
            borderBottom: '1px solid #D9D9D9',
          }}
          centered>
          <Tab label='Загрузить файл' {...a11yProps(0)} />

          <Tab label='Таблица данных' {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={current} index={0}>
          <UploadToExcel
            next={next}
            close={close}
            setExcelData={setExcelData}
            excelData={excelData}
            refetch={refetch}
          />
        </TabPanel>
        
        <TabPanel value={current} index={1}>
          <ExcelTable
            prev={prev}
            close={close}
            refetch={refetch}
            excelData={excelData}
            setExcelData={setExcelData}
          />
        </TabPanel>
      </Box>
    </CustomModal>
  );
}
